import { ApiResponse, DataObject } from "@/types";
import { sendData } from "@/services/api/fetcher";
import { useFormMutation } from "@/hooks/useFormMutation";
import { UseFormSetError } from "react-hook-form";
import {
  ChangePasswordPayload,
  ForgotPasswordPayload,
  FormValues,
  ResetPasswordPayload,
} from "./validation";

export const useLoginMutation = (setError: UseFormSetError<FormValues>) =>
  useFormMutation<ApiResponse<any>, Error, FormValues, FormValues>({
    mutationFn: (payload) => sendData("auth/login", payload, "POST"),
    loadingMessage: "Sedang login...",
    successMessage: "Login berhasil!",
    setError,
  });

export const useChangePassword = () =>
  useFormMutation<
    ApiResponse<DataObject<null>>,
    Error,
    ChangePasswordPayload,
    ChangePasswordPayload
  >({
    mutationFn: (payload) => sendData("auth/change-password", payload, "POST"),
    loadingMessage: "Sedang mengubah password...",
    successMessage: "Ubah password berhasil! Silahkan login kembali.",
  });

export const useForgotPassword = () =>
  useFormMutation<
    ApiResponse<DataObject<null>>,
    Error,
    ForgotPasswordPayload,
    ForgotPasswordPayload
  >({
    mutationFn: (payload) => sendData("auth/forgot-password", payload, "POST"),
    loadingMessage: "Sedang mengirim request...",
    successMessage: `Token reset password dikirim pada email Anda!`,
  });

export const useResetPassword = () =>
  useFormMutation<
    ApiResponse<DataObject<null>>,
    Error,
    ResetPasswordPayload,
    ResetPasswordPayload
  >({
    mutationFn: (payload) => sendData("auth/reset-password", payload, "POST"),
    loadingMessage: "Sedang mengubah password...",
    successMessage: `Password berhasil diubah! Silahkan login kembali menggunakan password baru Anda!`,
  });

export const useLogoutMutation = () =>
  useFormMutation<ApiResponse<any>, Error>({
    mutationFn: () => sendData("auth/logout", {}, "DELETE"),
    loadingMessage: "Sedang logout...",
    successMessage: "Anda telah logout!",
  });
